import api from '@/api'

export default {
  all() {
    return api.get('/outbound-orders')
  },

  approve(order) {
    return api.post(`/outbound-orders/${order.id}/approve`)
  },

  holdingArea(order) {
    return api.post(`/outbound-orders/${order.id}/holding-area`)
  },

  ship(order) {
    return api.post(`/outbound-orders/${order.id}/ship`)
  },

  deliver(order) {
    return api.post(`/outbound-orders/${order.id}/deliver`)
  },

  stage(order, picked) {
    return api.post(`/outbound-orders/${order.id}/stage`, { picked })
  }
}
